import React from 'react'
import copyright from "../config/copyright.json";

function Header() {
  return (
    <div className="title">
          <h3>{copyright.connexion.titre}</h3>
          {/* <p>{copyright.connexion.info}</p> */}
        </div>
  )
}

export default Header
